import create from 'zustand';

interface SettingsModalStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

/*
 * Whether the Settings modal is open. A store rather than local state because two unrelated places
 * open it: the user menu, and the sidebar's "Event feeds are off" notice. Not persisted.
 */
export const useSettingsModal = create<SettingsModalStore>((set) => ({
  open: false,
  setOpen: (open): void => {
    set({ open });
  }
}));
